import { CreateProduct, ProductType } from '@frontend/product/types';
import type React from 'react';
import { useState } from 'react';

import { useScreen } from '../useScreen';

export interface EnterProductInformationViewProps {
    product: CreateProduct;
    setProduct: React.Dispatch<React.SetStateAction<CreateProduct>>;
    submitDisabled: boolean;
    onSubmit: () => void;
}

const createInitialProduct = (product?: CreateProduct): CreateProduct => ({
    type: ProductType.CONSUMABLE,
    name: '',
    description: '',
    user_info: '',
    sku: '',
    ean: '',
    ...product
});

const useEnterProductInformation = (props: { wizard_id: string }): EnterProductInformationViewProps => {
    const { store, updateWizardData, onSubmit: navigateToNextStep } = useScreen(props.wizard_id);
    const [product, setProduct] = useState<CreateProduct>(createInitialProduct(store?.data.createProduct));

    const onSubmit = () => {
        updateWizardData({
            createProduct: product
        });
        navigateToNextStep();
    };

    return {
        product,
        setProduct,
        submitDisabled: !product.name || !product.type,
        onSubmit
    };
};

export default useEnterProductInformation;
